/**
 * Магазин токенов (BOT_SPEC §ШАГ 10) в стилистике карточек тарифов
 * из design-spec §7 (Profit Pass): пары «план — цена — фичи — CTA».
 */
import { useEffect, useState } from 'react';
import { api, apiMessage } from '../lib/api.js';
import type { TokenPackage } from '../lib/api.js';
import { haptic, openLink } from '../lib/telegram.js';
import { useApp } from '../state/app.js';

export function TokensScreen({
  supportContact,
  tokensRate,
}: {
  supportContact: string;
  /** Курс «токенов за $1» — подставляется в текст бонусной карточки. */
  tokensRate: number;
}) {
  const { me, showToast, art, t } = useApp();
  const [packages, setPackages] = useState<TokenPackage[]>([]);
  const [pending, setPending] = useState<string | null>(null);

  useEffect(() => {
    void api
      .packages()
      .then(({ packages: list }) => setPackages(list))
      .catch(() => showToast(t('app.tokens.load_failed')));
  }, [showToast]);

  async function openDeposit(packageId?: string) {
    haptic('medium');
    setPending(packageId ?? 'bonus');
    try {
      const { link } = await api.depositLink(packageId);
      openLink(link);
    } catch (err) {
      showToast(apiMessage(err, t, 'app.tokens.broker_silent'));
    } finally {
      setPending(null);
    }
  }

  return (
    <div className="screen">
      <section className="card card-lg card-violet">
        <span className="kicker">{t('app.tokens.promo')}</span>
        <h1 className="pass-title">
          {t('app.tokens.headline_lead')}
          <span className="grad-text">{t('app.tokens.headline_accent')}</span>
        </h1>
        <p className="body">
          {t('app.tokens.note')}
        </p>
        <div className="row-between">
          <span className="label">{t('app.tokens.you_have')}</span>
          <span className="pill">{me?.user.tokens ?? 0} 💎</span>
        </div>
      </section>

      <section className="pass-grid">
        {packages.map((pkg) => (
          <article
            key={pkg.id}
            className={`card pass-card ${pkg.badge === 'fire' ? 'is-pro' : ''}`}
          >
            {pkg.badge && (
              <span className={`pill ${pkg.badge === 'fire' ? 'pill-pink' : 'pill-green'} pass-badge`}>
                {pkg.badge === 'fire' ? t('app.tokens.badge_best') : t('app.tokens.badge_popular')}
              </span>
            )}
            <img
              className="pass-art"
              src={
                pkg.badge === 'fire'
                  ? art('art.pack_pro', '/art/pack-pro.webp')
                  : art('art.pack_basic', '/art/pack-basic.webp')
              }
              alt=""
              width={64}
              height={64}
            />
            <div className="pass-tokens">{pkg.tokens} 💎</div>
            <div className="pass-price">${pkg.priceUsd}</div>
            <div className="pass-crypto">{t('app.tokens.crypto_price', { price: pkg.priceCryptoUsd })}</div>
            {/* золото — у того же пакета, что и золотая карточка (бейдж fire),
                а не у последнего по порядку (аудит UI 2026-08-21, A3) */}
            <button
              type="button"
              className={`cta ${pkg.badge === 'fire' ? 'cta-gold' : ''} cta-block`}
              disabled={pending === pkg.id}
              onClick={() => void openDeposit(pkg.id)}
            >
              {pending === pkg.id ? t('app.tokens.opening') : t('app.tokens.buy')}
            </button>
          </article>
        ))}
      </section>

      <section className="card card-tinted bonus-card">
        <img className="bonus-art" src={art('art.bonus', '/art/bonus.webp')} alt="" loading="lazy" />
        <span className="kicker">{t('app.tokens.smart_move')}</span>
        <h2 className="card-title">{t('app.tokens.bonus_title')}</h2>
        <p className="body">
          {t('app.tokens.bonus_text', { rate: tokensRate })}
        </p>
        <button
          type="button"
          className="cta cta-gold cta-block"
          disabled={pending === 'bonus'}
          onClick={() => void openDeposit()}
        >
          {pending === 'bonus' ? t('app.tokens.opening') : t('app.tokens.bonus_button')}
        </button>
      </section>

      <section className="card">
        <span className="label">{t('app.tokens.crypto_title')}</span>
        <p className="body">{t('app.tokens.crypto_text', { supportContact })}</p>
      </section>
    </div>
  );
}
